import React from 'react';

const FileQuestion = ({ question: { file } }) => <>
    {file ? <a href={process.env.REACT_APP_API_URL + file?.fileUrl} className="c-download-file">Download file</a> : null}
</>;

export default FileQuestion;
